/*! modernizr 3.5.0 (Custom Build) | MIT *
 * https://modernizr.com/download/?-cssgradients-flexbox-fullscreen-geolocation-localstorage-notification-objectfit-pagevisibility-touchevents-vibrate-domprefixes-prefixes-setclasses-shiv-testallprops-testprop-teststyles !*/
!function(e,t,n){function r(e,t){return typeof e===t}function o(){var e,t,n,o,i,a,s;for(var l in C)if(C.hasOwnProperty(l)){if(e=[],t=C[l],t.name&&(e.push(t.name.toLowerCase()),t.options&&t.options.aliases&&t.options.aliases.length))for(n=0;n<t.options.aliases.length;n++)e.push(t.options.aliases[n].toLowerCase());for(o=r(t.fn,"function")?t.fn():t.fn,i=0;i<e.length;i++)a=e[i],s=a.split("."),1===s.length?Modernizr[s[0]]=o:(!Modernizr[s[0]]||Modernizr[s[0]]instanceof Boolean||(Modernizr[s[0]]=new Boolean(Modernizr[s[0]])),Modernizr[s[0]][s[1]]=o),b.push((o?"":"no-")+s.join("-"))}}function i(e){var t=E.className,n=Modernizr._config.classPrefix||"";if(w&&(t=t.baseVal),Modernizr._config.enableJSClass){var r=new RegExp("(^|\\s)"+n+"no-js(\\s|$)");t=t.replace(r,"$1"+n+"js$2")}Modernizr._config.enableClasses&&(t+=" "+n+e.join(" "+n),w?E.className.baseVal=t:E.className=t)}function a(){return"function"!=typeof t.createElement?t.createElement(arguments[0]):w?t.createElementNS.call(t,"http://www.w3.org/2000/svg",arguments[0]):t.createElement.apply(t,arguments)}function s(e,t){return!!~(""+e).indexOf(t)}function l(e){return e.replace(/([a-z])-([a-z])/g,function(e,t,n){return t+n.toUpperCase()}).replace(/^-/,"")}function c(){var e=t.body;return e||(e=a(w?"svg":"body"),e.fake=!0),e}function u(e,n,r,o){var i,s,l,u,f="modernizr",d=a("div"),p=c();if(parseInt(r,10))for(;r--;)l=a("div"),l.id=o?o[r]:f+(r+1),d.appendChild(l);return i=a("style"),i.type="text/css",i.id="s"+f,(p.fake?p:d).appendChild(i),p.appendChild(d),i.styleSheet?i.styleSheet.cssText=e:i.appendChild(t.createTextNode(e)),d.id=f,p.fake&&(p.style.background="",p.style.overflow="hidden",u=E.style.overflow,E.style.overflow="hidden",E.appendChild(p)),s=n(d,e),p.fake?(p.parentNode.removeChild(p),E.style.overflow=u,E.offsetHeight):d.parentNode.removeChild(d),!!s}function f(e,t){return function(){return e.apply(t,arguments)}}function d(e,t,n){var o;for(var i in e)if(e[i]in t)return n===!1?e[i]:(o=t[e[i]],r(o,"function")?f(o,n||t):o);return!1}function p(e){return e.replace(/([A-Z])/g,function(e,t){return"-"+t.toLowerCase()}).replace(/^ms-/,"-ms-")}function m(t,n,r){var o;if("getComputedStyle"in e){o=getComputedStyle.call(e,t,n);var i=e.console;if(null!==o)r&&(o=o.getPropertyValue(r));else if(i){var a=i.error?"error":"log";i[a].call(i,"getComputedStyle returning null, its possible modernizr test results are inaccurate")}}else o=!n&&t.currentStyle&&t.currentStyle[r];return o}function h(t,r){var o=t.length;if("CSS"in e&&"supports"in e.CSS){for(;o--;)if(e.CSS.supports(p(t[o]),r))return!0;return!1}if("CSSSupportsRule"in e){for(var i=[];o--;)i.push("("+p(t[o])+":"+r+")");return i=i.join(" or "),u("@supports ("+i+") { #modernizr { position: absolute; } }",function(e){return"absolute"==m(e,null,"position")})}return n}function g(e,t,o,i){function c(){f&&(delete P.style,delete P.modElem)}if(i=r(i,"undefined")?!1:i,!r(o,"undefined")){var u=h(e,o);if(!r(u,"undefined"))return u}for(var f,d,p,m,g,v=["modernizr","tspan","samp"];!P.style&&v.length;)f=!0,P.modElem=a(v.shift()),P.style=P.modElem.style;for(p=e.length,d=0;p>d;d++)if(m=e[d],g=P.style[m],s(m,"-")&&(m=l(m)),P.style[m]!==n){if(i||r(o,"undefined"))return c(),"pfx"==t?m:!0;try{P.style[m]=o}catch(y){}if(P.style[m]!=g)return c(),"pfx"==t?m:!0}return c(),!1}function v(e,t,n,o,i){var a=e.charAt(0).toUpperCase()+e.slice(1),s=(e+" "+N.join(a+" ")+a).split(" ");return r(t,"string")||r(t,"undefined")?g(s,t,o,i):(s=(e+" "+_.join(a+" ")+a).split(" "),d(s,t,n))}function y(e,t,r){return v(e,n,n,t,r)}var b=[],C=[],S={_version:"3.5.0",_config:{classPrefix:"",enableClasses:!0,enableJSClass:!0,usePrefixes:!0},_q:[],on:function(e,t){var n=this;setTimeout(function(){t(n[e])},0)},addTest:function(e,t,n){C.push({name:e,fn:t,options:n})},addAsyncTest:function(e){C.push({name:null,fn:e})}},Modernizr=function(){};Modernizr.prototype=S,Modernizr=new Modernizr,Modernizr.addTest("geolocation","geolocation"in navigator),Modernizr.addTest("notification",function(){if(!e.Notification||!e.Notification.requestPermission)return!1;if("granted"===e.Notification.permission)return!0;try{new e.Notification("")}catch(t){if("TypeError"===t.name)return!1}return!0}),Modernizr.addTest("localstorage",function(){var e="modernizr";try{return localStorage.setItem(e,e),localStorage.removeItem(e),!0}catch(t){return!1}});var x=S._config.usePrefixes?" -webkit- -moz- -o- -ms- ".split(" "):["",""];S._prefixes=x;var E=t.documentElement,w="svg"===E.nodeName.toLowerCase(),T="Moz O ms Webkit",_=S._config.usePrefixes?T.toLowerCase().split(" "):[];S._domPrefixes=_,Modernizr.addTest("cssgradients",function(){for(var e,t="background-image:",n="gradient(linear,left top,right bottom,from(#9f9),to(white));",r="",o=0,i=x.length-1;i>o;o++)e=0===o?"to ":"",r+=t+x[o]+"linear-gradient("+e+"left top, #9f9, white);";Modernizr._config.usePrefixes&&(r+=t+"-webkit-"+n);var s=a("a"),l=s.style;return l.cssText=r,(""+l.backgroundImage).indexOf("gradient")>-1});var N=S._config.usePrefixes?T.split(" "):[];S._cssomPrefixes=N;var j=S.testStyles=u;Modernizr.addTest("touchevents",function(){var n;if("ontouchstart"in e||e.DocumentTouch&&t instanceof DocumentTouch)n=!0;else{var r=["@media (",x.join("touch-enabled),("),"heartz",")","{#modernizr{top:9px;position:absolute}}"].join("");j(r,function(e){n=9===e.offsetTop})}return n});var z=function(t){var r,o=x.length,i=e.CSSRule;if("undefined"==typeof i)return n;if(!t)return!1;if(t=t.replace(/^@/,""),r=t.replace(/-/g,"_").toUpperCase()+"_RULE",r in i)return"@"+t;for(var a=0;o>a;a++){var s=x[a],l=s.toUpperCase()+"_"+r;if(l in i)return"@-"+s.toLowerCase()+"-"+t}return!1};S.atRule=z;var k={elem:a("modernizr")};Modernizr._q.push(function(){delete k.elem});var P={style:k.elem.style};Modernizr._q.unshift(function(){delete P.style});S.testProp=function(e,t,r){return g([e],n,t,r)};S.testAllProps=v,S.testAllProps=y,Modernizr.addTest("flexbox",y("flexBasis","1px",!0));var F=S.prefixed=function(e,t,n){return 0===e.indexOf("@")?z(e):(-1!=e.indexOf("-")&&(e=l(e)),t?v(e,t,n):v(e,"pfx"))};Modernizr.addTest("fullscreen",!(!F("exitFullscreen",t,!1)&&!F("cancelFullScreen",t,!1))),Modernizr.addTest("pagevisibility",!!F("hidden",t,!1)),Modernizr.addTest("vibrate",!!F("vibrate",navigator)),Modernizr.addTest("objectfit",!!F("objectFit"),{aliases:["object-fit"]});w||!function(e,t){function n(e,t){var n=e.createElement("p"),r=e.getElementsByTagName("head")[0]||e.documentElement;return n.innerHTML="x<style>"+t+"</style>",r.insertBefore(n.lastChild,r.firstChild)}function r(){var e=b.elements;return"string"==typeof e?e.split(" "):e}function o(e,t){var n=b.elements;"string"!=typeof n&&(n=n.join(" ")),"string"!=typeof e&&(e=e.join(" ")),b.elements=n+" "+e,c(t)}function i(e){var t=y[e[g]];return t||(t={},v++,e[g]=v,y[v]=t),t}function a(e,n,r){if(n||(n=t),f)return n.createElement(e);r||(r=i(n));var o;return o=r.cache[e]?r.cache[e].cloneNode():h.test(e)?(r.cache[e]=r.createElem(e)).cloneNode():r.createElem(e),!o.canHaveChildren||m.test(e)||o.tagUrn?o:r.frag.appendChild(o)}function s(e,n){if(e||(e=t),f)return e.createDocumentFragment();n=n||i(e);for(var o=n.frag.cloneNode(),a=0,s=r(),l=s.length;l>a;a++)o.createElement(s[a]);return o}function l(e,t){t.cache||(t.cache={},t.createElem=e.createElement,t.createFrag=e.createDocumentFragment,t.frag=t.createFrag()),e.createElement=function(n){return b.shivMethods?a(n,e,t):t.createElem(n)},e.createDocumentFragment=Function("h,f","return function(){var n=f.cloneNode(),c=n.createElement;h.shivMethods&&("+r().join().replace(/[\w\-:]+/g,function(e){return t.createElem(e),t.frag.createElement(e),'c("'+e+'")'})+");return n}")(b,t.frag)}function c(e){e||(e=t);var r=i(e);return!b.shivCSS||u||r.hasCSS||(r.hasCSS=!!n(e,"article,aside,dialog,figcaption,figure,footer,header,hgroup,main,nav,section{display:block}mark{background:#FF0;color:#000}template{display:none}")),f||l(e,r),e}var u,f,d="3.7.3",p=e.html5||{},m=/^<|^(?:button|map|select|textarea|object|iframe|option|optgroup)$/i,h=/^(?:a|b|code|div|fieldset|h1|h2|h3|h4|h5|h6|i|label|li|ol|p|q|span|strong|style|table|tbody|td|th|tr|ul)$/i,g="_html5shiv",v=0,y={};!function(){try{var e=t.createElement("a");e.innerHTML="<xyz></xyz>",u="hidden"in e,f=1==e.childNodes.length||function(){t.createElement("a");var e=t.createDocumentFragment();return"undefined"==typeof e.cloneNode||"undefined"==typeof e.createDocumentFragment||"undefined"==typeof e.createElement}()}catch(n){u=!0,f=!0}}();var b={elements:p.elements||"abbr article aside audio bdi canvas data datalist details dialog figcaption figure footer header hgroup main mark meter nav output picture progress section summary template time video",version:d,shivCSS:p.shivCSS!==!1,supportsUnknownElements:f,shivMethods:p.shivMethods!==!1,type:"default",shivDocument:c,createElement:a,createDocumentFragment:s,addElements:o};e.html5=b,c(t),"object"==typeof module&&module.exports&&(module.exports=b)}("undefined"!=typeof e?e:this,t),o(),i(b),delete S.addTest,delete S.addAsyncTest;for(var D=0;D<Modernizr._q.length;D++)Modernizr._q[D]();e.Modernizr=Modernizr}(window,document);
var helper =
    {
        de:
            {
                date:
                    {
                        monthNames: ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'],
                        monthNamesShort: ['Jan', 'Feb', 'Mar', 'Apr', 'Mai', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dez'],
                        dayNames: ['Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag'],
                        dayNamesShort: ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'],
                        dayNamesMin: ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'],
                    }
            },
        countries: {
            'de': 'Deutschland',
            'at': 'Österreich',
            'it': 'Italien',
            'ch': 'Schweiz',
            'li': 'Liechtenstein',
            'lu': 'Luxemburg',
            'nl': 'Niederlande',
            'be': 'Belgien',
            'fr': 'Frankreich'
        }
    };

var decodeEntities = (function()
{
    var cache = {},
        character,
        e = document.createElement('div');
    return function(html)
    {
        return html.replace(/([&][^&; ]+[;])/g, function(entity)
        {
            character = cache[entity];
            if(!character)
            {
                e.innerHTML = entity;
                if(e.childNodes[0])
                    character = cache[entity] = e.childNodes[0].nodeValue;
                else
                    character = '';
            }
            return character;
        });
    };
})();

var unescapeObj = function(obj)
{
    switch(typeof(obj))
    {
        case 'string':
            obj = decodeEntities(obj);
            break;
        case 'object':
            for(var key in obj)
            {
                obj[key] = unescapeObj(obj[key]);
            }
            break;
    }
    return obj;
};

var isEmpty = function(str)
{
    return (!str || 0 === str.length);
};

var stripHtmlTags = function(str)
{
    if ((str===null) || (str===''))
        return '';
    else
        str = str.toString();
    return str.replace(/<[^>]*>/g, '');
};

var support = function()
{
    window.location.href = "mailto:support@divera247.com";
};

var contact = function()
{
    window.location.href = "mailto:mail@divera247.com";
    return false;
};

var horst = function()
{
    window.location.href = "mailto:support@divera247.com";
    return false;
};

var tribble = function()
{
    window.location.href = "mailto:support@divera247.com";
    return false;
};

var scrollToEl = function(el)
{
    $el = $(el);
    if($el)
    {
        var offset = $el.offset();
        if(typeof(offset) != 'undefined')
        {
            $('html, body').animate({scrollTop: offset.top - 35}, 'slow');
        }
    }
};

var setFooterPosition = function()
{
    var $page = $('#page');
    var $footer = $('footer');
    var windowHeight = $(window).height();
    var pageHeight = $page.innerHeight();
    var footerHeight = $footer.height();

    if(pageHeight < windowHeight-footerHeight)
    {
        $footer.css({position:'absolute',bottom:0,top:'inherit',left:'0',right:'0'});
        // $page.css({marginBottom:footerHeight-5});
    } else {
      $footer.css({position:'absolute',top:pageHeight,bottom:'inherit',left:'0',right:'0'});
        // $page.css({marginBottom:-5});
    }
};

$(document).ready(function()
{
    var hasTouch = $('html').hasClass('touchevents');
    if($('html').hasClass('context-page'))
    {
        var $page = $('#page');
        var $footer = $('<footer>');
        var $footerMainWrap = $('<div class="mainwrap" />');
        var $footerMetaWrap = $('<div class="metawrap" />');

        $footer.append($('<a href="/" class="home"><i class="icon-247-divera247"></i></a>'));
        $footer.append($footerMainWrap);
        $footer.append($footerMetaWrap);

        $footerMainWrap.append($('#navTop ul.main').clone());
        $footerMetaWrap.append($('#navTop ul.meta').clone());
        $footerMainWrap.find('li.login, li.user').remove();
        $page.after($footer);

        setFooterPosition();
        $(window).resize(function()
        {
            setFooterPosition();
        });
    }
    else
    {
        if(hasTouch)
        {
            var touchPosition = 0;

            $('html')
                .on('touchstart', function(e)
                {
                    var touchList = e.originalEvent.touches;
                    if(touchList.length == 1)
                    {
                        touchPosition = touchList[0].screenX;
                    }
                })
                .on('touchmove', function(e)
                {
                    var touchList = e.originalEvent.touches;
                    if(touchList.length == 1 && touchPosition != 0)
                    {
                        var posX = touchList[0].screenX;
                        if(touchPosition + 100 < posX)
                        {
                            $('html').addClass('ucr-menu');
                        }
                        else if(touchPosition - 100 > posX)
                        {
                            $('html').removeClass('ucr-menu');
                        }
                    }
                })
                .on('touchend', function(e)
                {
                    touchPosition = 0;
                });
        }
        else
        {
            $('#ucrNavTrigger').mouseover(function()
            {
                if(!$('html').hasClass('ucr-menu'))
                {
                    $('html').addClass('ucr-menu');
                }
            });
        }

        $('#ucrNavTrigger').click(function()
        {
            if($('html').hasClass('ucr-menu'))
            {
                $('html').removeClass('ucr-menu');
            }
            else
            {
                $('html').addClass('ucr-menu');
            }
        });

        $('#ucrNav').hover(function()
        {
        }, function()
        {
            if($('html').hasClass('ucr-menu'))
            {
                $('html').removeClass('ucr-menu');
            }
        });
    }

    var hoverLiTimeout = null;
    var hoverUlTimeout = null;
    var menuHoverState = false;

    var navTop = $('#navTop > ul');
    var closeButton = $('<li class="close">').html('<svg width="24" height="24" viewBox="0 0 24 24"><path d="M24 20.188l-8.315-8.209 8.2-8.282-3.697-3.697-8.212 8.318-8.31-8.203-3.666 3.666 8.321 8.24-8.206 8.313 3.666 3.666 8.237-8.318 8.285 8.203z" fill="#fff"/></svg>');

    var closeTopNav = function()
    {
        navTop.removeClass('hover');
        $('#navTop > ul li').removeClass('hover');
        $('html').removeClass('freeze');
    }

    navTop.append(closeButton);
    closeButton.click(closeTopNav);

    navTop.hover(function()
    {
        clearTimeout(hoverUlTimeout);
    }, function()
    {
        hoverUlTimeout = setTimeout(function()
        {
            navTop.removeClass('hover');
            closeTopNav();
        }, 1000);
    });

    $('#navTop > ul > li > a').click(function(event)
    {
        if($(this).parent('li').hasClass('sub') && !$(this).parent('li').hasClass('hover'))
        {
            $('html').addClass('freeze');
            event.preventDefault();
            $(this).parent('li').siblings().removeClass('hover');
            $(this).parent('li').addClass('hover');
            navTop.addClass('hover');
            if(hasTouch)
            {
                $('html').addClass('freeze');
            }
        }
        else
        {
            window.location = event.currentTarget.href;
        }
    });

    $('#navTop > ul > li > a').dblclick(function(event)
    {
        window.location = event.currentTarget.href;
    });

    $('.subnav-outer.pulldown > .subnav-inner > ul > li.sub.active').addClass('open');
    $('.subnav-outer.pulldown > .subnav-inner > ul > li.sub > span.subnav-door').click(function(event)
    {
        event.preventDefault();
        $(this).parent('li').toggleClass('open');
    });

    $(document).keydown(function(event)
    {
        if((event.keyCode === 4 || event.keyCode === 13 || event.keyCode === 27) && $('#navTop > ul').hasClass('hover'))
        {
            $('#navTop .hover').removeClass('hover');
            $('html').removeClass('freeze');
            event.preventDefault();
        }
    });

    $(document).click(function(event)
    {
        if(navTop.hasClass('hover'))
        {
            if (!navTop.is(event.target) && navTop.has(event.target).length === 0)
            {
                closeTopNav();
                event.preventDefault();
            }
        }
    });

    if(hasTouch)
    {
        document.addEventListener("backbutton", function(event)
        {
            event.preventDefault();
            return false;
        }, false);

        $(window).on("navigate", function (event, data)
        {
            event.preventDefault();
            var direction = data.state.direction;
            if (direction == 'back' && navTop.hasClass('hover'))
            {
                $('#navTop .hover').removeClass('hover');
                $('html').removeClass('freeze');
            }
        });
    }

    var scrollPosY = window.scrollY;
    $(window).scroll(function()
    {
        if(window.scrollY > scrollPosY)
        {
            $('html').addClass('fixed-nav-top');
        }
        else
        {
            $('html').removeClass('fixed-nav-top');
        }
        if(window.scrollY > 50)
        {
            $('html').addClass('bg-nav-top-L2');
        }
        else
        {
            $('html').removeClass('bg-nav-top-L2');
        }

        scrollPosY = window.scrollY;
        if(scrollPosY < 0) scrollPosY = 0;
    });
});


// Global pure JS functions
function copyInputValue(inputId) {
  var inputElement = document.getElementById(inputId);

  inputElement.select();
  inputElement.setSelectionRange(0, 99999);

  document.execCommand('copy');
}
